import React from "react";

/**
 * EDUHUB logo component.
 *
 * Props:
 *   size        – height in px (width is proportional, aspect ratio preserved)
 *   variant     – "dark" | "light"  (controls wordmark text colour)
 *   showWordmark – render the "EDUHUB" text beside the mark
 *   className   – extra wrapper classes
 */
export default function Logo({
  size = 40,
  variant = "dark",
  showWordmark = false,
  className = "",
}) {
  const wordmarkColor = variant === "light" ? "#F9F8F6" : "#0B132B";
  const subColor =
    variant === "light" ? "rgba(249,248,246,0.60)" : "#4A4A4A";

  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      {/* Logo image — white background blends with the light header */}
      <img
        src="/logo.png"
        alt="EDUHUB logo"
        width={size}
        height={size}
        draggable={false}
        style={{ width: size, height: size, objectFit: "contain", display: "block" }}
      />

      {showWordmark && (
        <span className="flex flex-col leading-none">
          <span
            className="font-serif text-2xl tracking-tight"
            style={{ color: wordmarkColor }}
          >
            EDUHUB
          </span>
          <span
            className="text-[10px] uppercase tracking-[0.22em] font-semibold mt-0.5"
            style={{ color: subColor }}
          >
            Academy
          </span>
        </span>
      )}
    </span>
  );
}
